// extracted by mini-css-extract-plugin
module.exports = {"rotatingCircleLogo":"AboutPrimarySection-module--rotatingCircleLogo--3vuS_"};